import { useEffect } from "react";

const SITE = "https://jewishmusiclab.com";

function setTag(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

/** Per-route title, description, canonical and social tags for the SPA. */
export default function usePageMeta({ title, description, path = "" }) {
  useEffect(() => {
    const full = title ? `${title} · Jewish Music Lab` : "Jewish Music Lab";
    document.title = full;
    setTag('meta[name="description"]', { name: "description", content: description });
    setTag('link[rel="canonical"]', { rel: "canonical", href: `${SITE}${path}` });
    setTag('meta[property="og:title"]', { property: "og:title", content: full });
    setTag('meta[property="og:description"]', { property: "og:description", content: description });
    setTag('meta[property="og:url"]', { property: "og:url", content: `${SITE}${path}` });
    setTag('meta[name="twitter:title"]', { name: "twitter:title", content: full });
    setTag('meta[name="twitter:description"]', { name: "twitter:description", content: description });
  }, [title, description, path]);
}
